import { Driver } from "../../types/driver.types";
import { removeUnnecessaryFields } from "./utils";

export const getInitialValues = (driver: Driver | null): Omit<Driver, "_id" | "password"> => {
  if (driver) {
    return removeUnnecessaryFields(driver);
  }

  return process.env.NODE_ENV === "development"
    ? removeUnnecessaryFields(null)
    : {
        drivingLicenseNumber: 0,
        drivingLicenseType: "VL",
        name: "",
        lastName: "",
        email: "",
        phone: "+33",
        civility: "",
        birthDate: new Date(),
        creationDate: new Date(),
        manuallyActive: true,
        transporter: "",
        selectedChapters: [],
      };
};
